import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const GiftIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path d="M11 14H6v5h5v-5zm2 0v5h5v-5h-5zm4.663-6H19a2 2 0 012 2v4h-1v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5H3v-4a2 2 0 012-2h1.337A3.5 3.5 0 0112 4.05 3.5 3.5 0 0117.663 8zM14.5 8A1.5 1.5 0 1013 6.5V8h1.5zm-5 0H11V6.5A1.5 1.5 0 109.5 8zM5 12h14v-2H5v2z" />
  </SvgIcon>
)
